import { Outlet, Navigate } from 'react-router-dom';
import { HOME } from './paths';
import { useAuthContext } from '../contexts/authContext';

export default function PublicRoute() {
    const { tokenAuth } = useAuthContext();

    if (tokenAuth) {
        return <Navigate to={HOME} />;
    }

    return (
        <div>
            <Outlet />
        </div>
    );
}
